module.exports = __webpack_public_path__ + "static/media/icon-snow.69e11073.png";